<pbc-filter [config]="BerichteFilterConfig" [filter]="berichte.filter$ | async" (filterChange)="berichte.filter$.next($event)"></pbc-filter>
